export enum AgentType {
  RS = 'Rasa'
}
